import type { LogEntry } from '../structuredLogger';

export enum NleEventType {
  ProjectChanged = 'no.mjoll.mimir.premiere.ProjectChangedEvent',
  LogMessage = 'no.mjoll.mimir.LogMessage',
  ActiveSequenceChanged = 'no.mjoll.mimir.premiere.ActiveSequenceChangedEvent',
  EncoderJob = 'no.mjoll.mimir.premiere.EncoderJobEvent',
}

export type NleEvent = { type: NleEventType };

/**
 * Communicate what's going on with the local Adobe Media Encoder that we
 * delegate rendering to.
 *
 * The events that are emitted by our code in the Adobe application JavaScript
 * context, and consumed here in the browser JavaScript context.
 */
export interface EncoderJobEvent {
  jobId: string,

  // When present, signifies successful completion.
  outputFilePath?: string,

  // When present, signifies failure
  errorMessage?: string,

  // When present and true, signifies cancellation
  canceled?: true,

  // When present, fraction of completion in [0, 1].
  progress?: number,
}

export interface ProjectChangedEvent {
  documentId?: string
}

export interface ActiveSequenceChangedEvent {
  documentId?: string;
}

export interface NleEventPayloadByType {
  [NleEventType.ProjectChanged]: ProjectChangedEvent;
  [NleEventType.LogMessage]: LogEntry;
  [NleEventType.ActiveSequenceChanged]: ActiveSequenceChangedEvent;
  [NleEventType.EncoderJob]: EncoderJobEvent;
}

export type NleEventBody<T extends NleEventType = NleEventType> = NleEventPayloadByType[T];

export const dvrLaunchEventName = 'dvr-workflow-integration-launched';